import { Box, BoxProps, Button, ButtonProps, forwardRef } from '@chakra-ui/react';
import { FocusEvent, MouseEvent, ReactElement, useState } from 'react';

export interface DropdownPopoverOptionProps extends ButtonProps {
  icon?: ReactElement;
  index?: number;
  label: string;

  /**
   * custom option properties applied to the option container
   */
  optionProps?: Partial<BoxProps>;

  /**
   * The alternative option displying content when the user is hovering or focusing using the keyboard
   */
  hoveredlabel?: string;
  hoveredIcon?: ReactElement;
  hoveredOptionProps?: Partial<BoxProps>;
  isDivider?: boolean;
  isSubHeader?: boolean;
}

export const DropdownPopoverOption = forwardRef<DropdownPopoverOptionProps, 'button'>(
  (inProps: DropdownPopoverOptionProps, ref) => {
    const {
      hoveredIcon,
      hoveredlabel,
      hoveredOptionProps,
      icon,
      index,
      isActive,
      label,
      onBlur: onBlurProp,
      onFocus: onFocusProp,
      onMouseEnter: onMouseEnterProp,
      onMouseLeave: onMouseLeaveProp,
      optionProps,
      value,
      ...otherProps
    } = inProps;

    const [isHovering, setIsHovering] = useState(false);

    const onMouseEnter = (e: MouseEvent<HTMLButtonElement>) => {
      setIsHovering(true);
      onMouseEnterProp?.(e);
    };

    const onMouseLeave = (e: MouseEvent<HTMLButtonElement>) => {
      setIsHovering(false);
      onMouseLeaveProp?.(e);
    };

    const onFous = (e: FocusEvent<HTMLButtonElement>) => {
      setIsHovering(true);
      onFocusProp?.(e);
    };

    const onBlur = (e: FocusEvent<HTMLButtonElement>) => {
      setIsHovering(false);
      onBlurProp?.(e);
    };

    return (
      <Button
        data-index={index}
        data-value={value}
        isActive={isActive}
        leftIcon={(isHovering ? hoveredIcon : undefined) ?? icon}
        ref={ref}
        size={'xs'}
        onBlur={onBlur}
        onFocus={onFous}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...otherProps}
      >
        {optionProps ? (
          <Box as='span' {...(isHovering ? hoveredOptionProps : optionProps)}>
            {(isHovering ? hoveredlabel : undefined) ?? label}
          </Box>
        ) : (
          <>{(isHovering ? hoveredlabel : undefined) ?? label}</>
        )}
      </Button>
    );
  },
);
